const holidays = {
  headerButtons: {
    create: 'Criar',
    delete: 'Remover',
  },

  table: {
    headers: {
      start: 'Início',
      end: 'Fim',
    },
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
  },

  create: {
    successToast: {
      body: 'O feriado foi adicionado com sucesso',
    },
    errorModal: {
      header: 'Ocorreu um Erro',
      body: 'Não foi possível criar feriado',
    },
  },
  delete: {
    successToast: {
      body: 'Os feriados foram excluídos com sucesso',
    },
    errorToast: {
      body: 'Não foi possível criar feriado',
    },
  },
  edit: {
    errorToast: {
      body: 'Não foi possível criar feriado',
    },
    successToast: {
      body: 'O feriado foi atualizado com sucesso',
    },
    errorModal: {
      header: 'Ocorreu um Erro',
      body: 'Não foi possível atualizar o feriado',
    },
    successModal: {
      header: 'Sucesso',
      body: 'Feriado atualizado!',
    },
  },

  forms: {
    header: {
      create: {
        title: 'Criar',
      },

      update: {
        title: 'Atualizar',
      },
    },

    details: {
      header: 'Detalhes',
      fields: {
        name: 'Nome',
      },
    },
    dates: {
      header: 'Intervalo de Datas',
      fields: {
        rangeSwitch: 'Intervalo de Datas',
        start: 'Início',
        end: 'Fim',
        date: 'Data',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },
  },
};

export default holidays;
